<div id="body_croquis" style="width:100%;">
  <nav id="bandeau_croquis">
    <span id="currentStorageSpan"></span>
    <ul id="ge-filemenus">
      <li>
        <a href="#">Fichier</a>
        <ul id="ul_fichier">
          <!-- <li><a href="#" onclick="handlePromise('Load')">Open...</a></li>
          <li><a href="#" onclick="handlePromise('Save')">Save</a></li> -->
          <li><a href="#" (click)="save_projet()">Enregistrer</a></li>
          <!-- <li><a href="#" (click)="load_projet()">Charger</a></li> -->
          <li><a href="#" onclick="myFloorplan.commandHandler.redo()">Refaire</a></li>
          <li><a href="#" (click)="retour_fiche_intervention($event)">Retour dossier</a></li>
        </ul>
      </li>
      <li>
        <a href="#">Vue</a>
        <ul>
          <li id="ge-viewoption-overviews"><a href="#" onclick="editorHelper.geHideShowWindow('ge-overviews-window', true)" id="ge-overview-windows-button">Aperçu</a></li>
          <li id="ge-viewoption-inspector"><a href="#" onclick="editorHelper.geHideShowWindow('ge-inspector-window', true)" id="ge-inspector-windows-button">Inspecteur</a></li>
          <li id="ge-viewoption-options"><a href="#" onclick="editorHelper.geHideShowWindow('optionsWindow', true)" id="optionsWindow-button">Options</a></li>

          <li>
						<a href="#" class="scaleItems" onclick="adjustScale('-')">-</a>
						<a href="#" class="scaleItems" id="scaleDisplay" onclick="adjustScaleDefault()">Échelle: 100%</a>
						<a href="#" class="scaleItems" onclick="adjustScale('+')">+</a>
					</li>
        </ul>
      </li>
    </ul>

    <div id="toolButtonsDiv" style="float: left;">
      <button class="toolButtons" onclick="updateButtons(myFloorplan.enableWallBuilding, this)">Créer mur</button>
      <!-- <button class="toolButtons" onclick="updateButtons(myFloorplan.enableDividerBuilding, this)">Créer mur séparateur</button> -->
      <button class="toolButtons" onclick="updateButtons(myFloorplan.disableWallBuilding, this)">Sélection</button>
      <button class="toolButtons" onclick="myFloorplan.commandHandler.undo()">Revenir</button>
      <button class="toolButtons" onclick="handlePromise('Supprimer')">Supprimer</button>
    </div>

    <p id="isAutoSavingP" style="display:none;"><input type="checkbox" id="isAutoSavingCheckbox" unchecked /> <label for="isAutoSavingCheckbox">Autosave
        Enabled</label></p>

    <mat-form-field class="ml-6" style="width: 215px;" [formGroup]="formSelectEtage">
        <!-- <mat-label>Niveau</mat-label> -->
        <mat-select formControlName="champ_etage" (selectionChange)="changement_etage_verification($event.value)">
            <mat-option *ngFor="let etage of etages" [value]="etage.id">{{getNomNiveau(etage.niveau_id)}}</mat-option>
        </mat-select>
        <!-- <button type="button" class="ml-4" MatSuffix mat-flat-button [color]="'primary'" (click)="ajouterNiveau()">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        </button> -->
    </mat-form-field>

    <!-- <p id="ge-header">GoFloorPlanner</p> -->
    <div id="ge-filename" style="float:right; visibility: hidden;">(Nouveau fichier)</div>
  </nav>

  <input type="file" id="file-input" style="display: none;" />

  <div id="ge-diagrams-container" style="display: flex;">
    <div id="ge-diagram-0" style="height: 800px; width: 100%; background: #DAE4E4; border: 1px solid black; "></div>
  </div>

  <div id="ge-palettes-window" style="visibility: visible" class="">
    <div id="ge-palettes-window-handle" class="ge-handle ui-draggable-handle">Palettes
      <!-- <button id="ge-palettes-window-close" class="ge-window-button ge-clickable" onclick="editorHelper.geHideShowWindow('ge-palettes-window')">X</button> -->
    </div>
    <div id="ge-palettes-container">

      <h3 id="title-palette-0">Portes et fenêtres</h3>
      <div id="parent-palette-0">
        <div id="ge-palette-0" style="height: 500px; background: lightgray; border: 1px solid black; "></div>
      </div>

      <h3 id="title-palette-1">Équipements</h3>
      <div id="parent-palette-1">
          <div id="ge-palette-1" style="height: 500px; background: lightgray; border: 1px solid black; "></div>
      </div>
  </div>

  <div id="ge-overviews-window" style="visibility: hidden" class="ge-draggable ui-draggable">
    <div id="ge-overviews-window-handle" class="ge-handle ui-draggable-handle">Aperçu<button id="ge-overviews-window-close"
        class="ge-window-button ge-clickable" onclick="editorHelper.geHideShowWindow('ge-overviews-window')">X</button></div>
    <!--<div id="ge-overviews-container">
<h3> Overview</h3><div>  -->
    <div id="ge-overview-0" style="height: 200px; background: white; border: 1px solid black; "></div>
  </div>
  <!--</div> -->
<!-- </div> -->

<div id="ge-inspector-window" style="visibility: hidden" class="ge-draggable ui-draggable">
  <div id="ge-inspector-window-handle" class="ge-handle ui-draggable-handle">Inspecteur<button id="ge-inspector-window-close"
      class="ge-window-button ge-clickable" onclick="editorHelper.geHideShowWindow('ge-inspector-window')">X</button></div>
  <div id="ge-inspector" class="inspector"></div>
</div>

<div id="optionsWindow" style="visibility: hidden;" class="ge-draggable ui-draggable">
  <div id="optionsWindow-handle" class="ge-handle ui-draggable-handle">Options <button id="optionsWindowClose" class="windowButtons ge-window-button ge-clickable"
      onclick="editorHelper.geHideShowWindow('optionsWindow')">X</button></div>
  Units
  <div id="unitsRow" class="row data">
    <form id="unitsForm" onchange="window.myFloorplan.changeUnits(this)">
      <div class="col-4">
        <input type="radio" name="units" id="centimeters" />Centimètre
      </div>
      <div class="col-4">
        <input type="radio" name="units" id="meters" checked />Mètre
      </div>
      <div class="col-4">
        <input type="radio" name="units" id="inches" />Pouce
      </div>
      <div class="col-4">
        <input type="radio" name="units" id="feet" />Pied
      </div>
    </form>
  </div>
  Grille
  <div id="gridRow" class="row">
    <div class="col-1">
      <label for="gridSizeInput" class="options_label" style="float: left;">Grosseur grille</label>
      <input id="gridSizeInput" placeholder="" class="unitsInput" onchange="window.myFloorplan.changeGridSize(this)" value="20" />
      <input id="gridSizeUnitsInput" class="unitsBox" value="cm" disabled />
    </div>

  </div>
  <div id="gridRow" class="row">
    <div class="col-1">
      <label for="unitsConversionFactorInput" class="options_label" style="float: left;">Unités/1px (à 100%)</label>
      <input id="unitsConversionFactorInput" placeholder="" onchange="window.myFloorplan.changeUnitsConversionFactor(this, document.getElementById('gridSizeInput'))"
        class="unitsInput" value=".02" />
      <input id="" class="unitsBox" value="cm" disabled />
    </div>
  </div>

  <div id="gridRow" class="row">
    <div class="col-1">
      <label for="epaisseurMurInput" class="options_label" style="float: left;">Épaisseur mur</label>
      <input id="epaisseurMurInput" placeholder="" onchange="updateWallThickness()"
        class="unitsInput" value="0.5" />
      <input id="" class="unitsBox" value="cm" disabled />
    </div>
  </div>

  <div id="gridRow" class="row">
    <div class="col-1">
      <label for="hauteurPlafondInput" class="options_label" style="float: left;">Hauteur plafond</label>
      <input id="hauteurPlafondInput" placeholder="" onchange="updateHauteurPlafond()"
        class="unitsInput" value="8" />
      <input id="" class="unitsBox" value="cm" disabled />
    </div>
  </div>

  Préférences
  <div id="miscRow" class="row data">
    <div class="col-1">
      <input type="checkbox" id="showGridCheckbox" onchange="window.myFloorplan.checkboxChanged('showGridCheckbox')" checked />
      Montrer grille
    </div>
    <div class="col-1">
      <input type="checkbox" id="gridSnapCheckbox" onchange="window.myFloorplan.checkboxChanged('gridSnapCheckbox')" checked />Snap grille
    </div>
    <div class="col-1">
      <input type="checkbox" id="wallGuidelinesCheckbox" onchange="window.myFloorplan.checkboxChanged('wallGuidelinesCheckbox')"
        checked /> Afficher les lignes directrices du mur
    </div>
    <div class="col-1">
      <input type="checkbox" id="wallLengthsCheckbox" onchange="window.myFloorplan.checkboxChanged('wallLengthsCheckbox')"
        checked /> Afficher les longueurs de mur
    </div>
    <div class="col-1">
      <input type="checkbox" id="wallAnglesCheckbox" onchange="window.myFloorplan.checkboxChanged('wallAnglesCheckbox')"
        checked /> Afficher les angles de mur
    </div>
    <div class="col-1">
      <input type="checkbox" id="onlySmallWallAnglesCheckbox" onchange="window.myFloorplan.checkboxChanged('onlySmallWallAnglesCheckbox')"
        checked /> Afficher uniquement les angles de mur extérieur
    </div>
  </div>
</div>

<!-- </div> -->

<!-- <div id="ge-footer">
  <span>Built with the <a href="https://gojs.net">GoJS Diagramming Library</a>, by <a href="https://nwoods.com">
      Northwoods Software</a>.</span>
</div> -->

<textarea style='visibility: hidden; display:none;' id='defaultModelTextarea'>

    { "class": "GraphLinksModel",
"copiesKey": false,
"modelData": {"units":"feet", "unitsAbbreviation":"ft", "unitsConversionFactor":0.05, "gridSize":10, "wallThickness":10, "preferences":{"showWallGuidelines":true, "showWallLengths":true, "showWallAngles":true, "showOnlySmallWallAngles":true, "showGrid":true, "gridSnap":true}},
"nodeDataArray": [
],
"linkDataArray": []}

</textarea>

</div>
